module.exports = __webpack_public_path__ + "static/media/tobirama.d562cce9.webp";